<template>
    <div id="inputBlock">
        <p>{{ commandHead }}</p>
        <input
        v-model="message"
        ref="textField"
        @keyup.enter="log"
        type="text"
        id="inputAnswer"
        />
        <!--ref="textField"-->
    </div>
    <input id="mobileButton" type="button" v-show="screenWidth<600" @click="log(message)" value="Weiter">
</template>
<!--use v-model to make it work-->

<script setup>
import { ref, defineEmits, defineProps } from 'vue';
const emit = defineEmits(['enterAnswer', 'log'])

const props = defineProps({
  commandHead: String,
  screenWidth: Number,
  message: null,
  modelValue: String,
  
})
const message = ref(props.message);
//const computedMessage = computed({
//  get() {
//    return message.value;
//  },
//  set(props.message){
//    message.value = props.message;
//  }
//});
//const textField = ref(props.message);
//message = props.message;
//const message = ref("");
//const message = toRef(props.message, 'message');
//const { textField } = toRef(props.message, 'message');
//message = props.text;
//const propsConverted = toRefs(props); 


function log(){
  emit('enterAnswer', message);
  emit('log');
}

//function focusVModel(){
//  //message.focus();
//}

</script>


<style scoped>
#inputBlock{
  display:flex;
  flex-direction: row;
  gap:none;
}
#firstRow{
  display:flex;
  flex-direction: column;
}
#secondRow{
  display:flex;
  flex-direction: column;
}

#tester{
  width:100%;
  background-color: #0f0;
  border:2px solid;
  border-color:#0f0;
  color:black;
}


input{
  width:4rem;
}
#inputAnswer{
  background-color: transparent;
  outline:none;
  border:none;
  color:#0f0;
  font-size:1.5rem;
}
#blankSpace{
  background-color:blue;
  width:22.5rem;
}
#mobileButton{
  width: 100%;
  font-size:1rem;
  color:black;
  background-color: #0f0;
  border: 2px solid;
  border-color:#0f0;
}
@media all and (max-width: 600px) {
  #inputAnswer{
    font-size:1rem;

  }
}
</style>